import { createDetailedValidator } from 'typecheck.macro';
import { makeAlgoliaIndex } from '../../schema/public-algolia/AlgoliaIndex';
import { useAlgoliaAutoComplete } from './useAutoComplete';

export const useAutoCompleteOccupations = (input?: string) =>
  useAlgoliaAutoComplete(OccupationIndex, input).map(({ occupation }) => ({
    label: occupation,
    value: occupation,
  }));

const OccupationIndex = makeAlgoliaIndex(
  'Occupations',
  createDetailedValidator<{ occupation: string }>(),
);
